<template>
	<ValidationProvider
		:vid="idLabel"
		:rules="{ required: { allowFalse: !required || isCheckboxGroup } }"
		:immediate="immediate"
		v-slot="{ failed }"
		slim
	>
		<div :class="{ 'form-check': true, checkbox: true, 'abc-checkbox': true, 'is-invalid-wrapper': failed }">
			<input
				type="checkbox"
				:class="{ 'form-check-input': true, 'is-invalid': failed }"
				:name="$id('check-input')"
				:id="$id('check-input')"
				:checked="isChecked"
				:disabled="disabled"
				v-bind="{
					value: isCheckboxGroup ? checkedValue : value,
				}"
				@change="change"
			/>
			<label class="form-check-label" :for="$id('check-input')">
				<slot></slot>
				<span class="required" v-if="required && !isCheckboxGroup">*</span>
			</label>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import '../Utils/validation';

export default {
	mixins: [formControlProps, validationProps],

	props: ['label', 'value', 'uncheckedValue', 'checkedValue', 'disabled'],

	methods: {
		change(event) {
			if (this.isCheckboxGroup) {
				if (this.value.indexOf(this.checkedValue) !== -1) {
					this.$emit(
						'input',
						this.value.filter((value) => value !== this.checkedValue)
					);
				} else {
					this.$emit('input', [...this.value, this.checkedValue]);
				}
			} else {
				this.$emit('input', event.target.checked ? this.checkedValue : this.uncheckedValue);
			}
		},
	},

	computed: {
		// Array values are assumed to be checkboxes part of a group
		isCheckboxGroup() {
			return Array.isArray(this.value);
		},

		isChecked() {
			return (
				(this.isCheckboxGroup && this.value.indexOf(this.checkedValue) !== -1) ||
				this.value === this.checkedValue
			);
		},
	},

	components: {
		ValidationProvider,
	},
};
</script>
